(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[257],{

/***/ "+2Bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./src/client/components/lines/smart-faq-line/SmartFaqLine.jsx
var __jsx = react_default.a.createElement;

function SmartFaqLine() {
  return __jsx("div", {
    id: "st-faq"
  });
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/smart-faq/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (SmartFaqLine);

/***/ })

}]);